import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "row"
}
const _hoisted_2 = { class: "col-4" }
const _hoisted_3 = { class: "col-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_platforms_accordion = _resolveComponent("platforms-accordion")!
  const _component_platforms_list = _resolveComponent("platforms-list")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.$q.screen.lt.md)
      ? (_openBlock(), _createBlock(_component_platforms_accordion, {
          key: 0,
          platforms: _ctx.platforms,
          "model-value": _ctx.modelValue,
          onLoaded: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit( 'loaded', $event))),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
        }, {
          header: _withCtx((scope) => [
            _renderSlot(_ctx.$slots, "header", _normalizeProps(_guardReactiveProps(scope)))
          ]),
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 8, ["platforms", "model-value"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_platforms_list, {
              platforms: _ctx.platforms,
              "model-value": _ctx.modelValue,
              class: "full-height",
              onLoaded: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit( 'loaded', $event))),
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
            }, {
              default: _withCtx((scope) => [
                _renderSlot(_ctx.$slots, "header", _normalizeProps(_guardReactiveProps(scope)))
              ]),
              _: 3
            }, 8, ["platforms", "model-value"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps({ isSplit : true })))
          ])
        ]))
  ]))
}